export default "__VITE_ASSET__877c9a2c__"